import {API} from '../API';
import PaginatedList from '../PaginatedList';
import Event from '../../models/Event';

const events = {
    get: async (filters = {}) => {
        const {data: response} = await API.get('/events', {
            params: filters,
        });

        const list = new PaginatedList();

        list.items = response.data.map((event) => new Event(event));
        list.page = response.meta.page;
        list.pageSize = response.meta.perPage;
        list.total = response.meta.total;

        return list;
    },
    getAll: async () => {
        const {data: response} = await API.get('/events/all');

        return {
            events: response.data.map((event) => new Event(event)),
        };
    },
    detail: async (id) => {
        const {data: response} = await API.get(`/events/${id}`);
        return {
            event: new Event(response.data),
        };
    },
    save: async (params) => {
        await API.post('/events', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json',
                type: 'formData',
            },
        });

        return {};
    },
    update: async (id, params) => {
        await API.put(`/events/${id}`, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Accept: 'application/json',
                type: 'formData',
            },
        });

        return {};
    },
    delete: async (id) => {
        await API.delete(`/events/${id}`);

        return {};
    },
    activate: async (id) => {
        await API.put(`/events/${id}/activate`);
        await API.post('/realtime/home/notify', {
            reason: 'home-events-updated',
        });

        return {};
    },
    deactivate: async (id) => {
        await API.put(`/events/${id}/deactivate`);
        await API.post('/realtime/home/notify', {
            reason: 'home-events-updated',
        });

        return {};
    },
};

export default events;
